import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import { FullUserFragmentDoc } from './FullUser.generated';
import type * as Types from './Types';

const defaultOptions = {} as const;
export type MeQueryVariables = Types.Exact<{ [key: string]: never }>;

export type MeQuery = {
  me: {
    username?: string | null;
    fullname?: string | null;
    birthdate?: string | null;
    source?: Types.SourceOfFunds | null;
    createdAt: string;
    investedUSD: number;
    stripeId?: string | null;
    _id: string;
    email: string;
    admin: boolean;
    agreement: { url?: string | null; id?: string | null; status: Types.AgreementStatus };
    address?: { line1: string; line2: string; line3: string; zip: string; city: string; countryCode: string } | null;
    company?: { name: string; phone: string; countryCode: string } | null;
    kyc: {
      tier: number;
      identity: { status: Types.VerificationStatus };
      document: { status: Types.VerificationStatus };
      boardMeeting: { status: Types.VerificationStatus };
    };
    state: {
      termsAccepted?: boolean | null;
      closeMigrationAlert?: boolean | null;
      acceptedNewTerms?: boolean | null;
      bonusDPS?: boolean | null;
      eligibleToBonusDPS: boolean;
    };
    wallet?: { address: string; balance_wDPS?: string | null } | null;
    referral: {
      code: string;
      refereeCount: number;
      gains?: string | null;
      referrer?: { _id: string; fullname?: string | null; email: string; referral: { code: string } } | null;
      details: Array<{
        referred: { _id: string; fullname?: string | null; email: string; referral: { code: string } };
      }>;
    };
    twoFA: { otp: boolean };
    deposits: Array<{
      _id: string;
      amount: number;
      currency: Types.FiatCurrency;
      status: Types.DepositStatus;
      method: Types.DepositMethod;
      createdAt: string;
      wallet: string;
      user: { _id: string; email: string };
    }>;
    transactions: Array<{
      _id: string;
      blockNumber: number;
      amount: string;
      rate: number;
      timestamp: string;
      transactionId: string;
      avaxAmount?: string | null;
      from: string;
    }>;
  };
};

export const MeDocument = /*#__PURE__*/ gql`
  query Me {
    me {
      ...FullUser
      agreement {
        url
      }
    }
  }
  ${FullUserFragmentDoc}
`;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
}
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export function refetchMeQuery(variables?: MeQueryVariables) {
  return { query: MeDocument, variables: variables };
}
